import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reduceIndex',
  pure: true
})
export class ReduceIndexPipe implements PipeTransform {

  transform(index: string): string {
    let splitted = index.split('.');
    return splitted[0] + '.' + splitted[1] + '.' + splitted[2];
  }

}
